import React, { useEffect, useRef, useState } from 'react';

export default function ZoomWrapper({ children }) {
  const zoom = 0.8;
  const contentRef = useRef(null);
  const [height, setHeight] = useState('auto');

  useEffect(() => {
    const content = contentRef.current;
    if (!content) {
      return undefined;
    }

    const updateHeight = () => {
      setHeight(content.offsetHeight * zoom);
    };

    updateHeight();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateHeight);
      return () => window.removeEventListener('resize', updateHeight);
    }

    const observer = new ResizeObserver(updateHeight);
    observer.observe(content);

    return () => observer.disconnect();
  }, []);

  return (
    <div style={{ height: height === 'auto' ? 'auto' : height + 100, overflow: 'hidden' }}>
      <div
        ref={contentRef}
        style={{
          transform: `scale(${zoom})`,
          transformOrigin: 'top left',
          width: `${100 / zoom}%`
        }}
      >
        {children}
      </div>
    </div>
  );
}
